import React, { useContext, useEffect, useState } from 'react';
import {IMasterMenuOption, IProps, IState} from './types';
import * as S from './styles';
import LogOut from './components/LogOut';
import Menu from './components/Menu';
import AppBar from './components/AppBar';
import ComingSoon from '@routes/private/ComingSoon';
import { default as D } from '@assets/themes/dimensions';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import { useDispatch } from 'react-redux';
import { openMenuAction } from '@state/openReducers/actions';
import { IUserType } from '@state/auth/types';

const MasterPage:React.FC<IProps> = (props) => {
  const dispatch = useDispatch();

  const [openMenu, setOpen] = useState(false);

  const authContext = useContext(AuthContext)  
  const initialMenuOptions: IMasterMenuOption[] = [
    {
      id: 1,
      title: "Studio Dashboard",
      url: "studio"
    },
    {
      id: 2,
      title: "All My Designs",
      url: "my-designs"
    },
    {
      id: 5,
      title: "Shared Files",
      url: "shared-files"
    }
  ]

  if (authContext.userData && authContext.userData.profile && (authContext.userData.profile.role === IUserType.ADMIN || (authContext.userData.profile.role === IUserType.DEALER_USER && authContext.dsPermissions?.includes("BRAND_LIBRARY")))) {
    initialMenuOptions.push(
    {
      id: 4,
      title: "Brand Library",
      url: 'brand-library'
    },
    )
  }

  if (authContext.userData && authContext.userData.profile && (authContext.userData.profile.role === IUserType.ADMIN || (authContext.userData.profile.role === IUserType.DEALER_USER && authContext.dsPermissions?.includes("TEMPLATE_MANAGEMENT")))) {
    initialMenuOptions.push(
    {
      id: 3,
      title: "Template Management",
      url: 'templates'
    }
    )
  }

  if (authContext.userData && authContext.userData.profile && (authContext.userData.profile.role === IUserType.ADMIN || authContext.userData.profile.role === IUserType.STAFF ) && authContext.dsPermissions?.includes("USER_MANAGEMENT")) {
    initialMenuOptions.push(
    {
      id: 6,
      title: "User Management",
      url: 'user-management'
    }
    )
  }
  

  const findTitle = () => {
    var title = "";
    const titleIndex = initialMenuOptions.findIndex((option: any) => (option.id === props.pageIndex));
    if (titleIndex >= 0)
      title = initialMenuOptions[titleIndex].title;
    return title;
  }

  const setOpenMenu = (value: boolean) => {
    setOpen(value);
    dispatch(openMenuAction(value));
  }

  return (
    <S.Root>
      <LogOut />
      <Menu 
        openMenu={openMenu} 
        initialMenuOptions={initialMenuOptions} 
        pageIndex={props.pageIndex}
      />
      <S.RightContainerInit style={{
        width: !openMenu ? `calc(100vw - ${D.VERTICAL_MENU_WIDTH + D.LOGOUT_WIDTH}px)` : `calc(100vw - ${D.LOGOUT_WIDTH}px)`
      }} >
        <AppBar 
          openMenu={openMenu} 
          setOpenMenu={setOpenMenu}
          initialMenuOptions={initialMenuOptions} 
          newTitle={props.newTitle ? props.newTitle : findTitle()}
          newHeight={props.newHeight}
          renderAction={props.renderAction}
        />
        <S.ContentContainer>
          {
            authContext.userData?.profile.role === IUserType.NOTALLOWED_DEALER_USER ?
              <ComingSoon upsell={true} />
              :
              props.children
          }
        </S.ContentContainer>
      </S.RightContainerInit>
    </S.Root>
  );
}

export default MasterPage;